module.exports = __webpack_public_path__ + "assets/images/ebcd0de73f9488e0f5960f4b85f2f858.svg";